import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.335 10.42c.12-1.218.954-2.198 2.163-2.397 1.704-.281 4.685-.594 9.502-.594 4.817 0 7.798.313 9.503.594 1.208.199 2.043 1.179 2.162 2.398.158 1.598.335 4.109.335 7.293 0 3.185-.177 5.696-.335 7.294-.12 1.219-.954 2.199-2.162 2.398-1.705.28-4.686.594-9.503.594s-7.798-.313-9.502-.594c-1.209-.2-2.043-1.18-2.163-2.398A75.372 75.372 0 0 1 4 17.714c0-3.184.178-5.695.335-7.293Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.999 7.429c.188-.807.588-1.704.902-2.332.263-.528.75-.903 1.333-.982A13.08 13.08 0 0 1 16 4c.723 0 1.32.054 1.765.115.584.08 1.07.454 1.333.982.313.628.714 1.525.902 2.332M22.857 8v19.429M9.143 8v19.429M7.713 20.571h2.857M24.288 20.571H21.43"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "checked-bag"}) } }